import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/pork_hero.jpg';
import imgHeroMobile from './i/mobile/pork_hero.jpg';
import porkSvg from './i/svg/pork_stamp.svg';
import porkSvgFr from './i/svg/pork_stamp_fr.svg';
import arrow from '../../../../assets/images/hero-arrow.png';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Pork = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food pork">
                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="hero" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="hero" />
                    }
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    
                    {props.lang === 'en' ? <img className="img-svg" src={porkSvg} alt={"pork"} /> : <img className="img-svg" src={porkSvgFr} alt={"pork"} /> }
                    {props.lang === 'en' && <p>A&W is the first North American restaurant chain to serve pork that’s raised without the use of antibiotics. Plus, all our pork is locally sourced from Canadian farms. Because food as awesome as bacon and sausage deserves to be done right.</p>}
                    {props.lang === 'fr' && <p>A&W est la première chaîne de restaurants en Amérique du Nord à servir du porc élevé sans antibiotiques. De plus, notre porc provient toujours d’éleveurs canadiens. Parce que des aliments aussi savoureux que le bacon et la saucisse méritent d’être faits de la bonne façon.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>
            
            <div className="blockwrap our-food faq-block pork">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/breakfast`}>
                    {props.lang !== 'fr' ? 
                        <><span>Pork</span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ sur notre</span> porc<Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="pork" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Pork;